var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.108 15.013c.01-.065.015-.132.014-.198V3.547l.115.245c.113.24.268.459.457.646l3.16 3.16a1.183 1.183 0 0 0 1.514.166 1.143 1.143 0 0 0 .149-1.715L8.802.335a1.143 1.143 0 0 0-1.616 0L1.47 6.05a1.143 1.143 0 0 0 .114 1.715c.478.32 1.117.25 1.514-.166l3.166-3.154c.168-.168.309-.36.417-.572l.155-.343v11.223a1.183 1.183 0 0 0 .96 1.206 1.143 1.143 0 0 0 1.31-.945z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLong);
export default __webpack_public_path__ + "static/media/arrow-long.3487907a6c84c6913caab72aae690820.svg";
export { ForwardRef as ReactComponent };